import { render } from "./CoBrandBlueprint.vue?vue&type=template&id=06ef0ad5&scoped=true"
import script from "./CoBrandBlueprint.vue?vue&type=script&lang=js"
export * from "./CoBrandBlueprint.vue?vue&type=script&lang=js"

import "./CoBrandBlueprint.vue?vue&type=style&index=0&id=06ef0ad5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ef0ad5"]])

export default __exports__